<template>
  <div>
    <div class="flex justify-start whs">
      <span v-for="wh in whs" :key="wh.key" :class="{'active':curWh == wh.key}" @click="setWh(wh.key)">{{wh.name}}</span>
    </div>
     <div class="flex items-start">
      {{ $t('您的购物车共有{num}件商品').replace('{num}', cart_infoLength) }}
    </div>
    <div class="my-8" v-if="cart_infoLength">
      <CartBody></CartBody>
    </div>
    <div v-if="cart_infoLength">
      <CartFoot :curWh="curWh"></CartFoot>
    </div>
    <div v-else class="flex-center w-full mt-10rem">
      <img :src="require(`@/assets/image/暂无数据.png`)" />
    </div> 
  </div>
</template>
<script>
import CartBody from "/src/components/mine/cart/cartBody.vue";
import CartFoot from "/src/components/mine/cart/cartFoot.vue";
import { computed, ref } from "@vue/composition-api";
import bus from "@/API/util/bus.js";

export default {
  components: {  CartBody, CartFoot },
  setup(props, ctx) {
    // start whs
    const whs = ref([
      {
        key:'origin',
        name:'现货'
      },
      {
        key:'presell',
        name:'预售'
      }
    ])
    const curWh = ref('origin')
    const setWh = async(key)=>{
      curWh.value = key
      await getCartLists()
      bus.emit("dealOrder", []);
      bus.emit("checked", false);
    }
    // end
    const cartLists = ref()
    const getCartLists = async () => {
      ctx.root.$doing()
      let res = await ctx.root.$callapi('trade/getMyCartList',{wh:curWh.value})
      ctx.root.$done()
      if (res.code == 0 && res.data) {
        cartLists.value = res.data
        ctx.root.$store.commit("SAVE_CART", res.data);

      }
    }
    getCartLists()
    const cart_info = computed(() => {
      return ctx.root.$store.state.cart.cart;
    });
    const cart_infoLength = computed(() =>
      cart_info?.value?.length ? cart_info.value.length : 0
    );

    return { cart_infoLength, cartLists, whs,curWh,setWh };
  },
};
</script>
<style scoped lang="scss">
@import "@/style/theme.scss";
.whs{
  margin-bottom:12px;

  span{
    display:inline-block;
    width:3.4rem;
    text-align:center;
    padding-bottom:8px;
    margin-right:30px;
    cursor:pointer;
    &.active{
      position:relative;
      color: #34B66B;
      &:after{
        content:'';
        display:inline-block;
        position:absolute;
        left:50%;
        bottom:0;
        transform:translateX(-50%);
        width:100%;
        height:2px;
        background:#34B66B;
      }
    }
  }
}
</style>
